"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var icons_material_1 = require("@mui/icons-material");
var material_1 = require("@mui/material");
var SectionTitle_1 = __importDefault(require("../../../components/SectionTitle"));
var TableComponent_1 = __importDefault(require("../../../components/TableComponent"));
var TablePaginationComponent_1 = __importDefault(require("../../../components/TablePaginationComponent"));
var ChipStatusContainer_1 = __importDefault(require("../../../containers/ChipStatusContainer"));
var utilities_1 = require("../../../utilities");
var hooks_1 = require("../../../hooks");
var styles_1 = require("../../../styles");
var translations_1 = require("../../../translations");
var context_1 = require("../../../context");
var react_toastify_1 = require("react-toastify");
var ReportHistoryList = function () {
    var _a, _b;
    var headerContainer = (0, react_1.useRef)(null);
    var _c = (0, context_1.useGlobalLoading)(), updateLoading = _c.updateLoading, updateLoadingDescription = _c.updateLoadingDescription, resetLoading = _c.resetLoading;
    var _d = (0, hooks_1.useFetchHistories)(), reportHistoryData = _d.data, isLoading = _d.isLoading, isFetching = _d.isFetching;
    var handleDownloadReport = function (report_history) {
        updateLoading(true);
        var progress = 0;
        setTimeout(function () {
            var intervalID = setInterval(function () {
                if (progress === 100) {
                    resetLoading();
                    clearInterval(intervalID);
                    react_toastify_1.toast.success("Descarga completa: ".concat(report_history.report_name));
                    var file = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,".concat(report_history.output);
                    var link = document.createElement('a');
                    link.href = file;
                    link.setAttribute('download', report_history.report_name);
                    document.body.appendChild(link);
                    link.click();
                }
                else {
                    progress++;
                    updateLoadingDescription("Descargando archivo: ".concat(progress, "%"));
                }
            }, 60);
        }, 1000);
    };
    return ((0, jsx_runtime_1.jsxs)(styles_1.WrapperPage, { children: [(0, jsx_runtime_1.jsx)(material_1.Paper, __assign({ elevation: 0, sx: { marginBottom: '30px' }, ref: headerContainer }, { children: (0, jsx_runtime_1.jsx)(SectionTitle_1.default, { title: "Historial de Reportes" }) })), (0, jsx_runtime_1.jsxs)(material_1.Paper, { children: [(0, jsx_runtime_1.jsx)(TableComponent_1.default, { variant: "normal", isLoading: isLoading || isFetching, rows: (_a = reportHistoryData === null || reportHistoryData === void 0 ? void 0 : reportHistoryData.data) !== null && _a !== void 0 ? _a : [], keyExtractor: function (item) { return item.id; }, stickyHeader: true, maxHeight: "calc(100vh - ".concat(headerContainer.current &&
                            ((_b = headerContainer.current) === null || _b === void 0 ? void 0 : _b.clientHeight) + 240, "px)"), columns: [
                            {
                                label: 'Datos del Ejecutor',
                                field: 'execute_by',
                                type: 'text',
                                valueGetter: function (_a) {
                                    var row = _a.row;
                                    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ component: 'h6', fontWeight: "500", fontSize: 15, variant: "body1" }, { children: row.execute_by.full_name })) }));
                                },
                            },
                            {
                                label: 'Cliente B2B',
                                field: 'merchant',
                                align: 'left',
                                type: 'text',
                                valueGetter: function (_a) {
                                    var row = _a.row;
                                    return row.merchant.company_name;
                                },
                            },
                            {
                                label: 'Tipo de Reporte',
                                field: 'report_type',
                                align: 'left',
                                type: 'text',
                                valueGetter: function (_a) {
                                    var row = _a.row;
                                    return translations_1.localeEs['report_type'][row.report_type];
                                },
                            },
                            {
                                label: 'Nombre del Archivo',
                                field: 'report_name',
                                align: 'left',
                                type: 'text',
                                valueGetter: function (_a) {
                                    var row = _a.row;
                                    return row.report_name;
                                },
                            },
                            {
                                label: 'Estado',
                                field: 'status',
                                align: 'center',
                                type: 'text',
                                valueGetter: function (_a) {
                                    var row = _a.row;
                                    return ((0, jsx_runtime_1.jsx)(ChipStatusContainer_1.default, { status: row.status }));
                                },
                            },
                            {
                                label: 'Fecha de Registro',
                                field: 'created_at',
                                align: 'right',
                                type: 'text',
                                valueGetter: function (_a) {
                                    var row = _a.row;
                                    return (0, utilities_1.formatDate)({ date: row.created_at });
                                },
                            },
                            {
                                label: 'Opciones',
                                align: 'right',
                                field: 'actions',
                                type: 'text',
                                valueGetter: function (_a) {
                                    var row = _a.row;
                                    return ((0, jsx_runtime_1.jsx)(material_1.Stack, __assign({ direction: "row", justifyContent: "flex-end", spacing: "5px" }, { children: (0, jsx_runtime_1.jsx)(material_1.Tooltip, __assign({ title: "Descargar reporte" }, { children: (0, jsx_runtime_1.jsx)(material_1.IconButton, __assign({ color: "default", onClick: function () { return handleDownloadReport(row); } }, { children: (0, jsx_runtime_1.jsx)(icons_material_1.Download, {}) })) })) })));
                                },
                            },
                        ] }), (0, jsx_runtime_1.jsx)(TablePaginationComponent_1.default, { total: (reportHistoryData === null || reportHistoryData === void 0 ? void 0 : reportHistoryData.data)
                            ? reportHistoryData === null || reportHistoryData === void 0 ? void 0 : reportHistoryData.metadata.pagination.total
                            : 0 })] })] }));
};
exports.default = ReportHistoryList;
